import deepDiff from 'deep-diff';

// src/helpers/customers/reducer/reducer.ts
var customersReducerHasChanges = (state, data) => {
  const { originalData } = state;
  if (originalData === null && data === null) {
    return false;
  }
  if (originalData === null) {
    return true;
  }
  const hasChanges = (deepDiff(originalData, data) || []).length > 0;
  return hasChanges;
};

export { customersReducerHasChanges };
